/**
 * 环境配置管理
 * 集中管理所有环境变量，避免在代码各处直接使用 import.meta.env
 */

export const getEnvConfig = () => {
  // WebSocket 基础 URL，支持环境变量配置
  // 本地开发时使用当前主机（通过 vite 代理），部署时使用环境变量配置的域名
  const getWsBaseUrl = () => {
    // 如果配置了环境变量，直接使用
    if (import.meta.env.VITE_WS_BASE_URL) {
      return import.meta.env.VITE_WS_BASE_URL;
    }

    // 本地开发环境：使用当前主机（vite 代理会转发）
    if (import.meta.env.DEV) {
      const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
      return `${protocol}//${window.location.host}`;
    }

    // 生产环境：从 apiBaseUrl 派生（移除 http/https 协议，添加 ws/wss）
    const apiBaseUrl = import.meta.env.VITE_API_BASE_URL || '/api';
    try {
      // 如果是完整 URL，解析并使用
      const url = new URL(apiBaseUrl);
      const protocol = url.protocol === 'https:' ? 'wss:' : 'ws:';
      return `${protocol}//${url.host}`;
    } catch {
      // 如果是相对路径，使用当前主机
      const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
      return `${protocol}//${window.location.host}`;
    }
  };

  return {
    apiBaseUrl: import.meta.env.VITE_API_BASE_URL || '/api',
    wsBaseUrl: getWsBaseUrl(),
    wechatAppId: import.meta.env.VITE_WECHAT_APP_ID || '',
  };
};

// 导出常用配置项
export const envConfig = getEnvConfig();
